<template>
    <div id="PaymentDiv">
    </div>
</template>

<script>
export default {
  name: 'PaymentSection',
  props: [],
  components: {
  },
  beforeCreate () {
  },
  data () {
    return {}
  },
  created () {
  },
  mounted () {
    this.$router.push('/address')
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/web/Book/Secure/Payment.vue